import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/employment-types')({
  staticData: { breadcrumb: 'Employment Types', breadcrumbKey: 'K_BREADCRUMB_EMPLOYMENT_TYPES' },
});
